import { render, staticRenderFns } from "./CreatorUser.vue?vue&type=template&id=28f04913&"
import script from "./CreatorUser.vue?vue&type=script&lang=js&"
export * from "./CreatorUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports